"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var classnames_1 = __importDefault(require("classnames"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

require("./PasswordRules.scss");

function PasswordRules(_a) {
  var passwordValidation = _a.passwordValidation;
  var length = passwordValidation.length,
      upper = passwordValidation.upper,
      small = passwordValidation.small,
      digit = passwordValidation.digit,
      other = passwordValidation.other;
  var classes = {
    length: classnames_1.default({
      "passRules__square pl-3": !length
    }),
    upper: classnames_1.default({
      "passRules__square pl-3": !upper
    }),
    small: classnames_1.default({
      "passRules__square pl-3": !small
    }),
    digit: classnames_1.default({
      "passRules__square pl-3": !digit
    }),
    other: classnames_1.default({
      "passRules__square pl-3": !other
    })
  };
  return react_1.default.createElement("div", {
    className: "passRules d-md-inline-block w-100"
  }, react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "info",
    transparent: true,
    className: "align-items-start"
  }, react_1.default.createElement("div", {
    className: "py-2"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "mb-2 text-gray",
    color: "disabled",
    weight: "medium"
  }, "Votre mot de passe doit contenir :"), react_1.default.createElement("ul", {
    className: "list-unstyled m-0"
  }, react_1.default.createElement("li", {
    className: classes.length
  }, length && react_1.default.createElement(react_theme_components_1.SzIcon, {
    variant: "bold",
    icon: "check",
    className: "normal text-primary-brand mr-1"
  }), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    tag: "span",
    color: "disabled",
    weight: "medium"
  }, "Minimum 8 caract\xE8res")), react_1.default.createElement("li", {
    className: classes.upper
  }, upper && react_1.default.createElement(react_theme_components_1.SzIcon, {
    variant: "bold",
    icon: "check",
    className: "normal text-primary-brand mr-1"
  }), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    tag: "span",
    color: "disabled",
    weight: "medium"
  }, "Une majuscule")), react_1.default.createElement("li", {
    className: classes.small
  }, small && react_1.default.createElement(react_theme_components_1.SzIcon, {
    variant: "bold",
    icon: "check",
    className: "normal text-primary-brand mr-1"
  }), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    tag: "span",
    color: "disabled",
    weight: "medium"
  }, "Une minuscule")), react_1.default.createElement("li", {
    className: classes.digit
  }, digit && react_1.default.createElement(react_theme_components_1.SzIcon, {
    variant: "bold",
    icon: "check",
    className: "normal text-primary-brand mr-1"
  }), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    tag: "span",
    color: "disabled",
    weight: "medium"
  }, "Un chiffre")), react_1.default.createElement("li", {
    className: classes.other
  }, other && react_1.default.createElement(react_theme_components_1.SzIcon, {
    variant: "bold",
    icon: "check",
    className: "normal text-primary-brand mr-1"
  }), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    tag: "span",
    color: "disabled",
    weight: "medium"
  }, "Un caract\xE8re sp\xE9cial"))))));
}

exports.default = PasswordRules;